import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CreditCardService, ErrorHandlerService, AuthService, CommonSettings, CREDITCARD_VENDOR } from 'epay-library';
import { IEMPCCPayment } from 'epay-library/lib/features/employer/models/payment/creditcard/employerCCPayment';

@Component({
  selector: 'emp-cc-submit',
  templateUrl: './empccsubmit.component.html',
})
export class EMPCCSubmitComponent implements OnChanges {
  @Input() baseurl = '';
  @Input() secondaryIdAlias = '';
  @Input() creditCardVendorId = 0;
  @Input() creditCardDisclaimer = '';
  @Input() creditCardPayment: IEMPCCPayment = {} as IEMPCCPayment;

  creditCardVendor: any;

  paymentheader: string[] = ['Last Name', 'SSN', 'Case Number', 'Amount'];
  transactionId = '';
  errorMessage = '';
  totalCCPayment = 0;

  goToCivitek = false;
  goToFortPoint = false;
  creditCardUrl = '';
  civitekOriginKey = '';
  fortPointStateCode = '';
  stateName = '';

  disableCreatePaymentButton: boolean = false;
  createPaymentButtonText = 'Continue';

  constructor(
    private creditCardService: CreditCardService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService
  ) {
    this.transactionId = '';
    this.stateName = CommonSettings.StateName;
  }

  ngOnChanges() {
      this.creditCardUrl = CommonSettings.FortPointCreditCardUrl;
      this.fortPointStateCode = "CO";

      //console.log("CC URL ", this.creditCardUrl)
      //console.log("CC STATE CODE ", this.fortPointStateCode)

    if (this.secondaryIdAlias !== '') {
      this.paymentheader = [
        'Last Name',
        'SSN',
        this.secondaryIdAlias,
        'Amount',
      ];
    } else {
      this.secondaryIdAlias = 'Case Number';
    }
  }

  createCCPayment() {
    this.disableCreatePaymentButton = true;
    this.createPaymentButtonText = 'Processing....';
    this.creditCardPayment.confirm = true;

    this.totalCCPayment = this.creditCardPayment.totalAmount;
    this.creditCardService
      .insertEmployerCreditCardAttempt(this.baseurl, this.creditCardPayment)
      .subscribe({
        next: (success: any) => {
          //console.log('CC ATTEMPT********* ', success);

          this.transactionId = success.value.transactionId;
          if (this.transactionId === '') {
            console.log(
              'Did not receieve transactionId for Credit card payment...'
            );
          } else {
            this.authService.logout(this.baseurl, true);

            this.goToFortPoint = true;

            //if (+this.creditCardVendorId === CREDITCARD_VENDOR.FORTPOINT) {
              this.goToFortPoint = true;
              //console.log('GOING TO FP');
            //}
          }
        },
        error: (error: any) => {
          this.logError(error);
          this.handleError(error.status);
        },
      });
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    console.log('error', error);
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}

